import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from "@app/core/services/auth.guard";
import {PortalDefaultRedirectComponent} from "@app/core/components/portal-default-redirect.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: PortalDefaultRedirectComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'accept-invitation',
    loadChildren: () => import('./features/store-invitation/store-invitation-routing.module').then(m => m.StoreInvitationRoutingModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'orders',
    loadChildren: () => import('./features/orders/orders-routing.module').then(m => m.OrdersRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'redemptions',
    loadChildren: () => import('./features/redemptions/redemptions-routing.module').then(m => m.RedemptionsRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'transactions',
    loadChildren: () => import('./features/transactions/transactions.module').then(m => m.TransactionsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'biller',
    loadChildren: () => import('./features/biller/biller.module').then(m => m.BillerModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'redemptionpoints',
    loadChildren: () => import('./features/redemption-point/redemption-point-routing.module').then(m => m.RedemptionpointointRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'vouchers',
    loadChildren: () => import('./features/vouchers/vouchers-routing.module').then(m => m.VouchersRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'voucher-bonus',
    loadChildren: () => import('./features/voucher-bonus/voucher-bonus.module').then(m => m.VoucherBonusModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'ecommerce',
    loadChildren: () => import('./features/ecommerce/ecommerce-routing.module').then(m => m.EcommerceRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'settings',
    loadChildren: () => import('./features/settings/settings-routing.module').then(m => m.SettingsRoutingModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'taxi',
    loadChildren: () => import('./features/taxi-office/taxi-office.module').then(m => m.TaxiOfficeModule),
    canActivate: [AuthGuardService],
    data: { authPolicy: 'PROVIDER', providerPortal: 'TAXI_OFFICE' },
  },
  {
    path: 'transit',
    loadChildren: () => import('./features/transit/transit.module').then(m => m.TransitModule),
    canActivate: [AuthGuardService],
    data: { authPolicy: 'PROVIDER', providerPortal: 'TRANSIT_OPERATOR' },
  },
  {
    path: 'login',
    redirectTo: 'auth/login'
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
